import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgMon = function SvgMon(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 48 48"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#1C024E",
        fillRule: "evenodd",
        d: "M24 48C10.8 48 0 37.2 0 23.88.12 10.68 10.8-.118 24.12.002 37.32.121 48 10.801 48 24.241 47.88 37.32 37.2 48 24 48",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#836EF9",
        d: "M24 8C19.38 8 8 19.38 8 24s11.38 16 16 16 16-11.38 16-16S28.62 8 24 8m-2.493 25.15c-1.949-.532-7.187-9.695-6.656-11.643.53-1.949 9.694-7.187 11.642-6.656 1.949.53 7.187 9.694 6.656 11.642-.53 1.949-9.694 7.187-11.642 6.656"
    })));
};

export { SvgMon as ReactComponent };
//# sourceMappingURL=MON.svg.es.js.map
